var _defs, _path, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortraitN(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ShapeLayer",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.8,116.6l6.5-2,8.4-5.8,8.6-7.1,2.3-3.6,1.4-7.3.6-5.8,3.2-.6,2.5-8,2.8-7.1s1.4-2.8,1.4-3.4.4-3.8.4-3.8l-2.2-2.8-1.8-.8.8-10.2-.6-15.3-5-13.8-7.1-7.5-8.2-5.8-8.2-3.8-10.9-1-10.9,1-8.2,3.8-8.2,5.8-7.1,7.5-5,13.8-.6,15.3.8,10.2-1.8.8-2.2,2.8s.4,3.4.4,3.8,1.4,3.4,1.4,3.4l2.8,7.1,2.5,8,3.2.6.6,5.8,1.4,7.3,2.3,3.6,8.6,7.1,8.4,5.8,6.5,2h10.2Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "38.9 106 51.1 114.8 59 117.3 69.8 117.5 76.7 115 89.7 106 89.7 110.4 90.3 117 93.3 120.2 91.5 121.6 82.6 124.8 69.2 125.8 51.3 125.2 40.3 122.5 35.5 120.6 33.5 119 36.7 116.4 38.9 110.2 38.9 106"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortraitN);
export default __webpack_public_path__ + "static/media/portrait_n.5a9c56c381b14fffa0378fa1348f45bc.svg";
export { ForwardRef as ReactComponent };